module.exports = __webpack_public_path__ + "static/media/mobileDevice_fr.fc660494.png";